function sliders() {
	
	// Homepage inductee slider
	jQuery('.inductee-carousel').slick({
		dots: true,
		infinite: false,
		speed: 300,
		arrows: false,
		slidesToShow: 1,
		centerMode: false,
		variableWidth: false,
		mobileFirst: true,
		responsive: [{
			breakpoint: 992,
			settings: {
				dots: false,
				variableWidth: true
			}
		}]
	});

	// Single story slider
	jQuery('.slider__container').slick({
		arrows: true,
		appendArrows: jQuery('.slider__container').parent().find('.slider-arrows'),
		dots: true,
		slidesToShow: 1,
		appendDots: jQuery('.slider__container').parent().find('.slider-dots'),
		variableWidth: false,
	});
	
}